import { render } from "./NewTabButton.vue?vue&type=template&id=f1923efa"
import script from "./NewTabButton.vue?vue&type=script&lang=js"
export * from "./NewTabButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__